import { React, useState, useEffect } from "react";
import { Button, Table, Input } from "antd";
import { FilterOutlined, PrinterOutlined } from "@ant-design/icons";
import Footer from "components/Footer";
import FilterModal from "./components/FilterModal";
import PrintModal from "./components/PrintModal";
import { useSelector, useDispatch } from "react-redux";
import { fetchVendorClinicCounts } from "utilities/redux/slices/vendorsSlice";
import useRoleCheck from "utilities/hooks/roleCheck";
import ForbiddenScreen from "../403";

const Credentials = () => {
  const { hasPermission } = useRoleCheck();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const vendors = useSelector((state) => state.vendors.data);
  const pageView = hasPermission([
    "Admin.Basic",
    "Operations",
    "Marketing",
    "Sales.RM",
    "Sales.Exec",
    "Finance",
  ]);
  const [filters, setFilters] = useState({
    region: [],
    division: [],
    credentialType: [],
    vendor: [],
  });

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);

  const handleFilterButtonClick = () => {
    setIsFilterModalVisible(true);
  };

  const handleFilterModalClose = () => {
    setIsFilterModalVisible(false);
  };

  const handlePrintButtonClick = () => {
    setIsPrintModalVisible(true);
  };

  const handlePrintModalClose = () => {
    setIsPrintModalVisible(false);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    dispatch(fetchVendorClinicCounts({ search, filters }));
  }, [dispatch, search, filters]);

  const columns = [
    {
      title: "Vendor/Insurer",
      dataIndex: "vendorName",
      sorter: (a, b) => a.vendorName.localeCompare(b.vendorName),
    },
    {
      title: "Number of Clinics",
      dataIndex: "clinicCount",
      sorter: (a, b) => a.clinicCount - b.clinicCount,
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      vendor: newSelectedRowKeys,
    }));
  };

  const rowSelection = {
    filters: filters.vendor,
    onChange: onSelectChange,
  };
  if (!pageView) {
    return <ForbiddenScreen />;
  }
  return (
    <>
      <div className="p-8">
        <div className="flex">
          <Input.Search
            placeholder="Search Vendors"
            allowClear
            size="large"
            suffix="" // Remove the search icon
            onChange={handleSearch}
            className="mr-2"
          />
          <Button
            type="primary"
            size="large"
            icon={<FilterOutlined />}
            onClick={handleFilterButtonClick}
          >
            Filter
          </Button>
          <Button
            type="primary"
            size="large"
            className="ml-2"
            icon={<PrinterOutlined />}
            onClick={handlePrintButtonClick}
          >
            Print
          </Button>
        </div>

        <FilterModal
          open={isFilterModalVisible}
          onClose={handleFilterModalClose}
          filters={filters}
          setFilters={setFilters}
        />
        <PrintModal
          open={isPrintModalVisible}
          onClose={handlePrintModalClose}
          searchParam={search}
          filterParams={filters}
        />
        <div className="mt-4">
          <Table
            bordered
            rowSelection={rowSelection}
            columns={columns}
            dataSource={vendors}
          />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Credentials;
